var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DEPRECATED_ALIASES = void 0;
  const DEPRECATED_ALIASES = {
    ModuleDeclaration: "ImportOrExportDeclaration"
  };
  exports.DEPRECATED_ALIASES = DEPRECATED_ALIASES;

  //# sourceMappingURL=deprecated-aliases.js.map
  return exports;
}